// src/hooks/utils/eventMapper.js
export const mapEventsForCalendar = (events, type) =>
  events
    .map((e) => {
      const base = e.extendedProps || {};
      const startRaw =
        e.start ??
        e.date_time_planned_start_utc ??
        e.date_and_time ??
        base.date_time_planned_start_utc ??
        base.date_and_time;

      if (!startRaw) return null;

      const start = new Date(startRaw);

      // shared 8h logic
      let end = new Date(start.getTime() + 8 * 60 * 60 * 1000); // 8h duration
      const endOfDay = new Date(start);
      endOfDay.setHours(23, 59, 59, 999);

      if (end > endOfDay) {
        end = endOfDay; // clamp if it spills into next day
      }

      if (type === "event") {
        const ONE_HOUR = 60 * 60 * 1000;

        let end = new Date(start.getTime() + ONE_HOUR);

        // optional: clamp if user uploads a late time like 11:30pm
        const endOfDay = new Date(start);
        endOfDay.setHours(23, 59, 59, 999);
        if (end > endOfDay) {
          end = endOfDay;
        }

        return {
          id: e.id,
          title: e.name || e.title || e.description_event || "Event",
          start,
          end,
          extendedProps: {
            description:
              e.description_event &&
                e.description_event !== "NaN" &&
                e.description_event.trim() !== ""
                ? e.description_event
                : (e.schedule_name || e.name || "Event"),
            primary_technician: e.technician_name || "-",
            event_type: base.event_type,
          },
        };
      }
      else {
        // Work events
        return {
          id: e.id,
          title: e.description || base.description || e.name || "Work Event",
          start,
          end,
          extendedProps: {
            ...base,
            primary_technician:
              base.primary_technician || e.technician_name || "-",
            additional_technicians:
              base.additional_technicians || e.additional_technician || "-",
            property: base.property || e.property || "-",
            event_type: type,
          },
        };
      }
    })
    .filter(Boolean);
